var PassiveAuraType;
(function (PassiveAuraType) {
    PassiveAuraType["INFANTRY_BARRACKS_RECRUITMENT_TIME_BONUS"] = "InfantryBarracksRecruitmentTimeBonus";
    PassiveAuraType["SIEGE_BARRACKS_RECRUITMENT_TIME_BONUS"] = "SiegeBarracksRecruitmentTimeBonus";
    PassiveAuraType["ALL_BARRACKS_RECRUITMENT_TIME_BONUS"] = "AllBarracksRecruitmentTimeBonus";
    PassiveAuraType["AZTEC_TEMPLE_RECRUITMENT_TIME_BONUS"] = "AztecTempleRecruitmentTimeBonus";
    PassiveAuraType["RANGED_BARRACKS_RECRUITMENT_TIME_BONUS"] = "RangedBarracksRecruitmentTimeBonus";
    PassiveAuraType["TREASURE_HUNT_ATTEMPT_GENERATION_TIME_BONUS"] = "TreasureHuntAttemptGenerationTimeBonus";
    PassiveAuraType["IMPERIAL_GUARD_PRODUCTION_TIME_BONUS"] = "ImperialGuardProductionTimeBonus";
    PassiveAuraType["MAYA_ARCHERS_PRODUCTION_TIME_BONUS"] = "MayaArchersProductionTimeBonus";
    PassiveAuraType["CARCASSONNE_SENTINELS_PRODUCTION_TIME_BONUS"] = "CarcassonneSentinelsProductionTimeBonus";
    PassiveAuraType["HEAVY_INFANTRY_PRODUCTION_TIME_BONUS"] = "HeavyInfantryProductionTimeBonus";
    PassiveAuraType["RESEARCH_POINT_GENERATION_TIME_BONUS"] = "ResearchPointGenerationTimeBonus";
    PassiveAuraType["DOCK_WORKER_TIME_BONUS"] = "DockWorkerTimeBonus";
    PassiveAuraType["HEAVY_INFANTRY_HIT_POINT_MOD"] = "HeavyInfantryHitPointMod";
    PassiveAuraType["LIGHT_INFANTRY_HIT_POINT_MOD"] = "LightInfantryHitPointMod";
    PassiveAuraType["RANGED_HIT_POINT_MOD"] = "RangedHitPointMod";
    PassiveAuraType["CAVALRY_HIT_POINT_MOD"] = "CavalryHitPointMod";
    PassiveAuraType["SIEGE_HIT_POINT_MOD"] = "SiegeHitPointMod";
    PassiveAuraType["BASTION_HIT_POINT_MOD"] = "BastionHitPointMod";
    PassiveAuraType["TOTAL_HIT_POINT_MOD"] = "TotalHitPointMod";
    PassiveAuraType["RANGED_DAMAGE_MOD"] = "RangedDamageMod";
    PassiveAuraType["LIGHT_INFANTRY_DAMAGE_MOD"] = "LightInfantryDamageMod";
    PassiveAuraType["HEAVY_INFANTRY_DAMAGE_MOD"] = "HeavyInfantryDamageMod";
    PassiveAuraType["CAVALRY_DAMAGE_MOD"] = "CavalryDamageMod";
    PassiveAuraType["SIEGE_DAMAGE_MOD"] = "SiegeDamageMod";
    PassiveAuraType["AZTEC_CROCODILE_DAMAGE_MOD"] = "AztecCrocodileDamageMod";
    PassiveAuraType["TOTAL_DAMAGE_MOD"] = "TotalDamageMod";
    PassiveAuraType["LIGHT_INFANTRY_CRITICAL_HIT_CHANCE_MOD"] = "LightInfantryCriticalHitChanceMod";
    PassiveAuraType["RANGED_CRITICAL_HIT_CHANCE_MOD"] = "RangedCriticalHitChanceMod";
    PassiveAuraType["HEAVY_INFANTRY_CRITICAL_HIT_CHANCE_MOD"] = "HeavyInfantryCriticalHitChanceMod";
    PassiveAuraType["CAVALRY_HIT_RATE_MOD"] = "CavalryHitRateMod";
    PassiveAuraType["CAVALRY_MOVEMENT_SPEED_MOD"] = "CavalryMovementSpeedMod";
    PassiveAuraType["RANGED_CRITICAL_HIT_DAMAGE_MOD"] = "RangedCriticalHitDamageMod";
    PassiveAuraType["GRANTS_CAPITAL_CITY_WORKER"] = "GrantsCapitalCityWorker";
    PassiveAuraType["GRANTS_TRADE_WORKER"] = "GrantsTradeWorker";
    PassiveAuraType["GRANTS_ARABIA_WORKER"] = "GrantsArabiaWorker";
    PassiveAuraType["MYSTERY_CHEST"] = "MysteryChest";
    PassiveAuraType["TREASURE_HUNT_ATTEMPTS_CAP"] = "TreasureHuntAttemptsCap";
    PassiveAuraType["RESEARCH_POINT_GENERATION_CAP"] = "ResearchPointGenerationCap";
    PassiveAuraType["EXTRA_COMMANDER_SLOT"] = "ExtraCommanderSlot";
    PassiveAuraType["GOLD_PRODUCTION_MOD"] = "GoldProductionMod";
    PassiveAuraType["FOOD_PRODUCTION_MOD"] = "FoodProductionMod";
    PassiveAuraType["CAPITAL_CITY_GOODS_PRODUCTION_MOD"] = "CapitalCityGoodsProductionMod";
    PassiveAuraType["TRADE_OFFER_MOD"] = "TradeOfferMod";
    PassiveAuraType["GEARS_FROM_WONDER_CONTRIBUTION_MOD"] = "GearsFromWonderContributionMod";
    PassiveAuraType["EGYPT_PRODUCTION_MOD"] = "EgyptProductionMod";
    PassiveAuraType["CHINA_PRODUCTION_MOD"] = "ChinaProductionMod";
    PassiveAuraType["MAYA_PRODUCTION_MOD"] = "MayaProductionMod";
    PassiveAuraType["VIKINGS_TAVERN_PRODUCTION_MOD"] = "VikingsTavernProductionMod";
    PassiveAuraType["ARABIA_GOODS_PRODUCTION_MOD"] = "ArabiaGoodsProductionMod";
    PassiveAuraType["ARABIAN_BAZAAR_OFFERS_MOD"] = "ArabianBazaarOffersMod";
})(PassiveAuraType || (PassiveAuraType = {}));
export default PassiveAuraType;
